import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiParameters } from 'src/app/configs/api.params';

/**
 * @ignore
 */
@Injectable({
  providedIn: 'root'
})
export class LicensePlateService {

  constructor(private httpClient: HttpClient) { }

  getLicensePlatesRequests(): Observable<any> {
    return this.httpClient.get(`${apiParameters.url}/license-plate-requests`);
  }

  getLicensePlateRequest(requestId: string): Observable<any> {
    return this.httpClient.get(`${apiParameters.url}/license-plate-requests/${requestId}`);
  }

  addLicensePlateRequest(userId: string, body: FormData): Observable<any> {
    return this.httpClient.post(`${apiParameters.url}/users/${userId}/license-plate-requests`, body);
  }

  // Global
  getLicensePlates(): Observable<any> {
    return this.httpClient.get(`${apiParameters.url}/license-plates`).pipe(
      map((res: any) => {
        res.sort((a, b) => {
          return (
            (new Date(b.createdAt) as any) - (new Date(a.createdAt) as any)
          );
        });
        return res;
      })
    );;
  }

  addLicensePlate(body: FormData): Observable<any> {
    return this.httpClient.post(`${apiParameters.url}/license-plates`, body);
  }

  editLicensePlate(licensePlateId: string, body: FormData): Observable<any> {
    return this.httpClient.patch(`${apiParameters.url}/license-plates/${licensePlateId}`, body);
  }

  deleteLicensePlate(licensePlateId: string): Observable<any> {
    return this.httpClient.delete(`${apiParameters.url}/license-plates/${licensePlateId}`);
  }

  // Customer
  getCustomerLicensePlates(customerId: string): Observable<any> {
    return this.httpClient.get(`${apiParameters.url}/customers/${customerId}/license-plates`);
  }

  addLicensePlateToCustomer(customerId: string, body: any): Observable<any> {
    return this.httpClient.post(`${apiParameters.url}/customers/${customerId}/license-plates`, body);
  }

  deleteLicensePlateFromCustomer(customerId: string, licensePlateId: string): Observable<any> {
    return this.httpClient.delete(`${apiParameters.url}/customers/${customerId}/license-plates/${licensePlateId}`);
  }
}